import FormCommand from "../../components/controls/FormCommand/FormCommand";
import TextBox from "../../components/controls/TextBox/TextBox";

export function ChangePasword() {
    return (
        <div className="row">
            {/* <div className="col-4">
                <h1>Change password</h1>
            </div> */}
            <div className="col">
                <TextBox id="currentPassword" text="Current Password" type="password" />
                <hr />
                <TextBox id="newPassword" text="New Password" type="password" />
                <TextBox id="confirmPassword" text="Confirm Password" type="password" />

                <FormCommand commandText="Change password" />
            </div>
        </div>
    )
}